// Custom cursor stuff
document.addEventListener('DOMContentLoaded', () => {
	const cursorIcon = document.querySelector('#custom-cursor');
	const cursorDefault = document.querySelector('#custom-cursor #default');
	const cursorHover = document.querySelector('#custom-cursor #hover');
	let hoverable = document.querySelectorAll(
		'input, button, a, label, .cursor-pointer, .product-card .quick-add-box .field-item, select, .strong-slider .strong-dots .strong-dot, .close-button.close-popup'
	);

	hoverable.forEach(item => {
		item.addEventListener('mouseenter', e => {
			cursorDefault.style.opacity = 0;
			cursorHover.style.opacity = 1;
		})
		item.addEventListener('mouseleave', e => {
			cursorDefault.style.opacity = 1;
			cursorHover.style.opacity = 0;
		})
	})

	const cursorWidth = cursorIcon.getBoundingClientRect().width;
	const cursorHeight = cursorIcon.getBoundingClientRect().height;

	let lastCursorPos = {
		x: null,
		y: null,
		cursorAngle: null,
	}
	let currentCursorPos = {
		x: null,
		y: null,
		cursorAngle: null,
	}
	let cursorAngle = 0;
	const INTERVAL_POSITION = 5;
	const INTERVAL_ROTATION = 100;

	function setCurrentCursorProps() {
		// Apply translation (set to actual cursor position)
		cursorIcon.style.left = `${currentCursorPos.x - cursorWidth / 2}px`
		cursorIcon.style.top = `${currentCursorPos.y - cursorHeight / 2}px`

		// Ensure correct rotation transition direction
		while (Math.abs(lastCursorPos.cursorAngle - cursorAngle) > 180) {
			if (cursorAngle > lastCursorPos.cursorAngle) {
				cursorAngle -= 360;
			} else if (cursorAngle < lastCursorPos.cursorAngle) {
				cursorAngle += 360;
			}
		}
		// Apply rotation
		cursorIcon.style.setProperty('--rotate', `${cursorAngle - 90}deg`);
	}

	function updateCursor() {
		// Interval for updating cursor-position
		setInterval(setCurrentCursorProps, INTERVAL_POSITION);

		// Interval for updating cursor-rotation
		setInterval(() => {
			const delt = {
				x: lastCursorPos.x - currentCursorPos.x,
				y: lastCursorPos.y - currentCursorPos.y
			}
			if (Math.abs(delt.x) < 3 && Math.abs(delt.y) < 3) return;
			cursorAngle = (Math.atan2(delt.y, delt.x) * 180 / Math.PI);

			setCurrentCursorProps();

			lastCursorPos = { x: currentCursorPos.x, y: currentCursorPos.y, cursorAngle: cursorAngle };
		}, INTERVAL_ROTATION);
	}

	function enableListeners() {
		window.addEventListener('mousemove', e => {
			currentCursorPos = { x: e.clientX, y: e.clientY, cursorAngle: lastCursorPos.cursorAngle }
		})

		updateCursor();
	}

	enableListeners()
})